// extracted by mini-css-extract-plugin
export default {"shipping-page":"ShippingAddress_shipping-page__BMk34","footer":"ShippingAddress_footer__ZjQuL"};